import React from "react";
import { Bank } from "../../../api/apiTypes";

interface Props {
  banks: Bank[];
  selectedBanks: string[];
  loadingBanks: boolean;
  step1Error: string;
  onCheckboxChange: (bankId: string) => void;
  clearError: () => void;
}

const Step1SelectBanks: React.FC<Props> = ({
  banks,
  selectedBanks,
  loadingBanks,
  step1Error,
  onCheckboxChange,
  clearError,
}) => {
  return (
    // Errore e contatore restano fuori dall'area che scorre, cosi' il numero di
    // selezionate e' sempre visibile mentre si scorre l'elenco.
    <div className="flex flex-col gap-2 mt-6 max-h-[70vh]">

      {/* ERROR */}
      {step1Error && (
        <div className="p-2  text-red-800 border border-red-300 rounded mb-2">
          {step1Error}
        </div>
      )}

      {/* HEADER con contatore */}
      {!loadingBanks && (
        <div className="flex justify-end mb-1">
          <span className="text-sm text-textSecondary">
            Selezionate: <strong>{selectedBanks.length}</strong> / 16
          </span>
        </div>
      )}

      {/* LISTA BANCHE */}
      {loadingBanks ? (
        <div className="flex items-center justify-center h-32">
          <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-2 overflow-y-auto max-h-[55vh] pr-2">
          {banks.map((bank) => (
            <div
              key={bank.id}
              className="flex items-center justify-between p-2 border rounded hover:bg-gray-50 cursor-pointer"
              onClick={() => onCheckboxChange(bank.id)}
            >
              <span className="text-textPrimary">{bank.name}</span>
              <input
                type="checkbox"
                checked={selectedBanks.includes(bank.id)}
                onChange={() => {
                  onCheckboxChange(bank.id);
                  if (step1Error) clearError();
                }}
                onClick={(e) => e.stopPropagation()} // evita il toggle doppio
                className="accent-black"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Step1SelectBanks;
